import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Layout } from "@/components/Layout";
import { LayoutFr } from "@/components/LayoutFr";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServicePage from "@/pages/ServicePage";
import AreasIndex from "@/pages/AreasIndex";
import CityPage from "@/pages/CityPage";
import Indigenous from "@/pages/Indigenous";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import HomeFr from "@/pages/fr/HomeFr";
import ServicesIndexFr from "@/pages/fr/ServicesIndexFr";
import ServicePageFr from "@/pages/fr/ServicePageFr";
import VillesIndexFr from "@/pages/fr/VillesIndexFr";
import VillePageFr from "@/pages/fr/VillePageFr";
import ContactFr from "@/pages/fr/ContactFr";
import AboutFr from "@/pages/fr/AboutFr";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/security-services/" element={<ServicesIndex />} />
            <Route path="/security-services/:slug" element={<ServicePage />} />
            <Route path="/service-areas/" element={<AreasIndex />} />
            <Route path="/security-guards/:slug" element={<CityPage />} />
            <Route path="/indigenous-security/" element={<Indigenous />} />
            <Route path="/about/" element={<About />} />
            <Route path="/contact/" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/francais/" element={<LayoutFr />}>
            <Route index element={<HomeFr />} />
            <Route path="services-de-securite/" element={<ServicesIndexFr />} />
            <Route path="services-de-securite/:slug" element={<ServicePageFr />} />
            <Route path="villes/" element={<VillesIndexFr />} />
            <Route path="villes/:slug" element={<VillePageFr />} />
            <Route path="a-propos/" element={<AboutFr />} />
            <Route path="contact/" element={<ContactFr />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
